import posthog from "posthog-js";
import { config } from "./config";

/**
 * Shared by both entry points. Each page owns its own bundle, so this has to be
 * a module rather than living in one entry and being imported by the other.
 */
export const initPosthog = (): void => {
  if (!config.posthogKey) return;
  const options = {
    api_host: config.posthogHost,
    capture_pageview: false,
    person_profiles: "identified_only" as const,
  };
  if (!(posthog as { __loaded?: boolean }).__loaded) posthog.init(config.posthogKey, options);
  else posthog.set_config(options);
};

export { posthog };
